<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Passageiros</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Passageiros',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <!-- v-if="$check(user, ['passengers.create'])" -->
                        <v-btn color="success" elevation="0" class="mr-2" :loading="exporting" @click="exportExcel">
                            <v-icon left small>mdi-file-excel-outline</v-icon>
                            Exportar
                        </v-btn>
                        <v-btn v-if="$check(['passengers.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            to="/passageiros/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="applyFilter">
                            <v-row>

                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense id="registration" label="Matrícula"
                                        v-model="dataList.filter.registration" hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <v-autocomplete dense id="customer" label="Empresa" :items="dataset.customers"
                                        v-model="dataList.filter.customer_id" item-value="id" item-text="name" outlined
                                        hide-details :loading="dataset.customerLoading"
                                        :search-input.sync="searchCustomer" cache-items :filter="() => true"
                                        no-data-text="Nenhuma empresa encontrada" clearable></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                    <v-btn id="btnClear" type="button" color="grey darken-1" text class="ml-2"
                                        @click="clearFilter">Limpar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:options="optionsChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum passageiro encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.id`]="{ item }">

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        {{ item.id }}
                                        <v-icon v-if="!item.address_iid" v-on="on" color="amber darken-2" class="ml-2"
                                            small>
                                            mdi-map-marker-alert
                                        </v-icon>

                                    </template>
                                    <span v-if="!item.address_iid && !item.address">Passageiro sem endereço — complete o
                                        cadastro para o cálculo de rota funcionar</span>
                                    <span v-else-if="!item.address_iid">Endereço sem localização no mapa — revise o
                                        cadastro</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:[`item.name`]="{ item }">
                                <span :class="{ 'text-red': item.blocked === 1, 'text-green': item.blocked === 0 }">
                                    {{ item.name }}
                                </span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['passengers.block'])" v-on="on" @click="blockItem(item)" size="large" class="mr-2">
                                                mdi-cancel
                                            </v-icon>
                                        </template>
                                        <span>{{ item.blocked === 1 ? 'Desbloquear passageiro' : 'Bloquear passageiro'
                                        }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['passengers.update'])" v-on="on" @click="editItem(item)" size="large" class="mr-2">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar passageiro</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['passengers.delete'])" v-on="on" @click="deleteItem(item)" size="large">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover passageiro</span>
                                    </v-tooltip>


                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- MODAL EXCLUIR PASSAGEIRO -->
        <v-dialog v-model="deleteDialog" persistent max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text>
                    Tem certeza que deseja remover o passageiro <strong>{{ itemToDelete ? itemToDelete.name : ''
                    }}</strong>?
                    Esta ação é irreversível.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="cancelDelete">Não</v-btn>
                    <v-btn color="red darken-1" text @click="confirmDeletePassenger">Sim, Remover</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--MODAL BLOQUEAR PASSAGEIRO-->
        <v-dialog v-model="blockDialog" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text>
                    Tem certeza que deseja {{ itemToBlock && itemToBlock.blocked === 1 ? 'desbloquear' : 'bloquear' }} o
                    passageiro
                    <strong>{{ itemToBlock ? itemToBlock.name : '' }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="cancelBlock">Não</v-btn>
                    <v-btn :color="itemToBlock && itemToBlock.blocked === 1 ? 'green darken-1' : 'red darken-1'" text
                        @click="confirmBlockPassenger">
                        Sim, {{ itemToBlock && itemToBlock.blocked === 1 ? 'Desbloquear' : 'Bloquear' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import debounce from 'lodash/debounce'

Vue.use(VueLodash)

const STORAGE_KEY = 'passengerList.state';

function loadState() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (_) {
        return {};
    }
}

function saveState(state) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_) { /* storage indisponível */ }
}

export default {
    name: "PassengerList",

    data: () => ({
        dataset: {
            data: {},
            customers: [],
            customerLoading: false,
        },
        searchCustomer: '',
        lastQueryKey: null,
        dataList: {
            filter: {
                name: '',
                registration: '',
                customer_id: null,
            },
            headers: [
                { text: "ID", value: "id" },
                { text: "Nome", value: "name" },
                { text: "Matricula", value: "registration" },
                { text: "Cliente", value: "customer.name" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },

        exporting: false,
        deleteDialog: false,
        itemToDelete: null,
        blockDialog: false,
        itemToBlock: null,
    }),

    created() {
        this.restoreState();
        this.load(true);
    },

    watch: {
        searchCustomer(val) {
            this.loadCustomers(val);
        },
    },

    methods: {
        restoreState() {
            const state = loadState();

            if (state.filter) {
                this.dataList.filter = { ...this.dataList.filter, ...state.filter };
            }

            if (state.customer && state.customer.id) {
                this.dataset.customers = [state.customer];
                this.dataList.filter.customer_id = state.customer.id;
            }

            if (state.options) {
                this.dataList.options = { ...this.dataList.options, ...state.options };
            }
        },

        persistState() {
            const customerId = this.dataList.filter.customer_id;
            const stored = loadState().customer;
            const customer = this.dataset.customers.find((x) => x.id === customerId)
                || (stored && stored.id === customerId ? stored : null);

            saveState({
                filter: { ...this.dataList.filter },
                customer: customer ? { id: customer.id, name: customer.name } : null,
                options: {
                    page: this.dataList.options.page,
                    itemsPerPage: this.dataList.options.itemsPerPage,
                },
            });
        },

        optionsChanged(options) {
            this.dataList.options.page = options.page;
            this.dataList.options.itemsPerPage = options.itemsPerPage;
            this.load();
        },

        applyFilter() {
            this.dataList.options.page = 1;
            this.load(true);
        },

        clearFilter() {
            this.dataList.filter = { name: '', registration: '', customer_id: null };
            this.applyFilter();
        },

        buildQueryKey() {
            return JSON.stringify({
                page: this.dataList.options.page,
                limit: this.dataList.options.itemsPerPage,
                filter: this.dataList.filter,
            });
        },

        async load(force = false) {
            const key = this.buildQueryKey();

            // O v-data-table emite update:options ao montar e ao trocar página/itens por página;
            // evita carregar duas vezes a mesma consulta.
            if (!force && key === this.lastQueryKey) return;

            this.lastQueryKey = key;
            this.persistState();

            const search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v));

            this.dataList.loading = true;

            try {
                const result = await axios.get(`api/v2/passengers/list`, {
                    params: {
                        page: this.dataList.options.page,
                        limit: this.dataList.options.itemsPerPage,
                        search,
                    }
                });

                this.dataList.data = result.data.data;
                this.dataList.count = result.data.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        loadCustomers: debounce(async function (filter = '') {
            this.dataset.customerLoading = true;

            try {
                const result = await axios.get('api/v2/customers', { params: { start: 0, limit: 10, search: { name: filter } } });

                this.dataset.customers = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.customerLoading = false;
            }
        }, 500),

        editItem(item) {
            this.$router.push(`passageiros/${item.id}`);
        },

        deleteItem(item) {
            this.itemToDelete = item;
            this.deleteDialog = true;
        },

        async confirmDeletePassenger() {
            if (!this.itemToDelete) return;

            try {
                await axios.delete(`api/v2/passengers/${this.itemToDelete.id}`);
                if (this.$dialog && this.$dialog.notify) {
                    this.$dialog.notify.success('Passageiro removido com sucesso!', { position: 'top-right', timeout: 3000 });
                } else {
                    alert('Passageiro removido com sucesso!');
                }
                this.load();
            } catch (error) {
                console.error('Erro ao remover passageiro:', error);
                if (this.$dialog && this.$dialog.notify && this.$codes) {
                    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                } else {
                    alert('Erro ao remover passageiro. Verifique o console.');
                }
            } finally {
                this.deleteDialog = false;
                this.itemToDelete = null;
            }
        },

        cancelDelete() {
            this.deleteDialog = false;
            this.itemToDelete = null;
        },

        blockItem(item) {
            this.itemToBlock = item;
            this.blockDialog = true;
        },

        async confirmBlockPassenger() {
            if (!this.itemToBlock) return;

            const newBlockedStatus = this.itemToBlock.blocked === 1 ? 0 : 1;
            const actionText = newBlockedStatus === 1 ? 'bloqueado' : 'desbloqueado';

            try {
                await axios.patch(`api/v2/passengers/${this.itemToBlock.id}`, { blocked: newBlockedStatus });

                if (this.$dialog && this.$dialog.notify) {
                    this.$dialog.notify.success(`Passageiro ${this.itemToBlock.name} ${actionText} com sucesso!`, { position: 'top-right', timeout: 3000 });
                } else {
                    alert(`Passageiro ${this.itemToBlock.name} ${actionText} com sucesso!`);
                }
                this.load();
            } catch (error) {
                console.error(`Erro ao ${actionText} passageiro:`, error);
                if (this.$dialog && this.$dialog.notify && this.$codes) {
                    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                } else {
                    alert(`Erro ao ${actionText} passageiro. Verifique o console.`);
                }
            } finally {
                this.blockDialog = false;
                this.itemToBlock = null;
            }
        },

        cancelBlock() {
            this.blockDialog = false;
            this.itemToBlock = null;
        },

        async exportExcel() {
            this.exporting = true;
            try {
                const response = await axios.get('api/v2/passengers/export', {
                    params: { search: JSON.stringify(Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))) },
                    responseType: 'blob',
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'passageiros.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Erro ao exportar:', error);
                if (this.$dialog && this.$dialog.notify) {
                    this.$dialog.notify.error('Erro ao exportar passageiros.', { position: 'top-right', timeout: 5000 });
                }
            } finally {
                this.exporting = false;
            }
        },

    },
};
</script>

<style scoped>
.app-table .text-red {
    color: #EF5350 !important;
}

.app-table .text-green {
    color: #4CAF50 !important;
}
</style>
